import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';

import {Languages} from './shared/core/services/language/language.types';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: Languages.En,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
